import axios from './axios'

export const getWaitting = async () => {
    try {
        return await axios.get(`/romons.order/api/order/waitting`)
    } catch (error) {
        throw error
    }
}

export const getPurchaseHistories = async (type, req) => {
    try {
        return await axios.post(`/romons.order/api/${type}/histories`, req)
    } catch (error) {
        throw error
    }
}

export const getOrderStatus = async () => {
    try {
        return await axios.get(`/romons.order/api/order/status`)
    } catch (error) {
        throw error
    }
}

export const getOrderDetails = async (type, id) => {
    try {
        return await axios.get(`/romons.order/api/${type}/details/${id}`)
    } catch (error) {
        throw error
    }
}

export const exportOrder = async (id, options) => {
    try {
        return await axios.get(`/romons.order/api/order/export/${id}`, options)
    } catch (error) {
        throw error
    }
}

export const changeOrderStatus = async (req) => {
    try {
        return await axios.post(`/romons.order/api/manage/histories/save`, req)
    } catch (error) {
        throw error
    }
}

export const getSalesOrder = async (req) => {
    try {
        return await axios.post(`/romons.order/api/order/salesorder`, req)
    } catch (error) {
        throw error
    }
}